<template>
    <div class="relative flex flex-col h-screen">
        <img :src="getImage('mascot')" class="fixed papsi-mascot">
        <div class="flex flex-1 lg:flex-row flex-col">
            <SidebarSection>
                <div class="flex flex-col">
                    <LabelControl type="message" :content="$t('bip001')" />
                </div>
            </SidebarSection>
            <ContentSection @logout="logout">
                <div class="flex flex-col justify-center align-center items-center cards">
                    <div class="mb-2 mt-10">
                        <CardControl
                            @click="this.$router.push({ name: 'transactions-page', params: { code: 'SHR', type: 'shares' } });"
                            :title="$t('bip002')" icon_id="share_capital" :rectangle="true" :width="56" :height="10"
                            :icon_height="50" :icon_width="50" :margin="30" />
                    </div>
                    <div class="m-2">
                        <CardControl
                            @click="this.$router.push({ name: 'accounts-menu-page', params: { type: 'savings' } })"
                            :rectangle="true" :width="56" :height="10" :title="$t('bip003')" icon_id="savings"
                            :icon_height="50" :icon_width="50" :margin="30" />
                    </div>
                    <div class="m-2">
                        <CardControl
                            @click="this.$router.push({ name: 'accounts-menu-page', params: { type: 'loans' } })"
                            :rectangle="true" :width="56" :height="10" :title="$t('bip004')" icon_id="loans"
                            :icon_height="50" :icon_width="50" :margin="30"/>
                    </div>
                </div>
            </ContentSection>
        </div>
        <FooterSection />
    </div>

</template>

<script>
import SidebarSection from '@/components/sections/SidebarSection.vue';
import ContentSection from '@/components/sections/ContentSection.vue';
import FooterSection from '@/components/sections/FooterSection.vue';
import mixin from '@/mixins/controls.js';
import LabelControl from '@/components/controls/LabelControl.vue';
import CardControl from '@/components/controls/CardControl.vue';
import user from '@/services/user';

export default {
    mixins: [mixin],
    inject: ['setLoading', 'setError'],
    components: {
        SidebarSection,
        ContentSection,
        FooterSection,
        LabelControl,
        CardControl
    },
    mounted() {
        this.$emit('checkauth');
        // this.retrieveBalances();
    },
    data(){
        return {
            hash: this.$store.state.user.hash,
            uuid: this.$store.state.user.uuid,
            balance_ref: this.$store.state.user.balance_ref,
            balance_delay: parseInt(process.env.VUE_APP_BALANCE_FETCH_DELAY, 10),
        }
    },
    methods: {
        logout() {
            this.$emit('logout');
        },
        retrieveBalances() {
            const ledgers = this.$store.state.user.ledgers;
            if (ledgers.length > 0) {
                // this.$router.push({ name: 'balance-inquiry-page' });
                return;
            }
            this.setLoading(true);
            user.fetchBalances(this.hash, this.uuid, this.balance_ref).then((response) => {
                const balances = response.data.data;
                Object.entries(balances).forEach(([code, {total_balance, total_records, as_of}]) => {
                    this.$store.commit('addBalance', { code: code, balance: total_balance, records: total_records, as_of: as_of });
                });
                this.$router.push({ name: 'balance-inquiry-page' });
                this.setLoading(false);
            }).catch((error) => {
                if (error.response && error.response.status === 403) {
                    this.setLoading(false);
                    this.$router.push({ name: 'services-page', query: { existing_session: true } });
                }
                // else if (error.response && error.response.status === 417) {
                //     let timer = setTimeout(() => {
                //         this.retrieveBalances();
                //         clearTimeout(timer);
                //     }, this.balance_delay);
                // }
                this.showError(error.response.data.message);
                this.setLoading(false);
                this.$router.push({ name: "login-page" }); 
            });
        },
    }
};
</script>

<style scoped>
.papsi-mascot {
    bottom: 0;
    left: 0;
    width: 25rem;
}



@media (min-width: 2500px) {
  .card-container {
    height: 15rem !important;
    width:  75rem !important;
  }

  .cards {
    margin-top: 6rem !important;
  }
}
</style>
